import React from 'react';
import { observer } from 'mobx-react';
import { FormModal, FormModalBody } from 'common/ui/themes/disona/modals';
import { BLOCKED_WITHDRAWAL_MODAL_ID } from 'common/constants/profile.constants';
import { S } from '../style';

export const BlockedWithdrawDisona = observer(() => {
  return (
    <FormModal ModalId={BLOCKED_WITHDRAWAL_MODAL_ID}>
      <FormModalBody>
        <S.ContainerCentre>
          <S.BoldRed>Withdraw is not available</S.BoldRed>
          <S.Dimmer>Please contact technical support</S.Dimmer>
        </S.ContainerCentre>
      </FormModalBody>
    </FormModal>
  );
});
